import { render } from "./ChallengeTab.vue?vue&type=template&id=5cfe0d40"
import script from "./ChallengeTab.vue?vue&type=script&lang=js"
export * from "./ChallengeTab.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src52216049/src/wfyt-leaderboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__